module.exports = __webpack_public_path__ + "static/media/caravan.2a0d4883.svg";